import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const InlineBox = props => {
  const {
    children,
    className
  } = props;

  return (
    <div className={clsx('d-flex border-box w-100 align-items-center', className)} style={{ overflow: 'hidden', flexGrow: 0, flexShrink: 0 }}>
      {children}
    </div>
  );
};

InlineBox.propTypes = {
  className: PropTypes.string
};

export default InlineBox;
